import { Link } from "react-router-dom";
import { mergeClass } from "../../utils";
import { Button } from "../Button";
import { Spinner } from "../Loader";
import { useAtomValue } from "jotai";
import { hostDataAtom } from "../../atoms";

export const Banner = ({
  published,
  handlePublishPressed,
  isPublishing,
  modelsAndSingleItems,
}: {
  published: boolean | undefined;
  isPublishing: boolean;
  handlePublishPressed: () => void;
  modelsAndSingleItems?: string[];
}): JSX.Element => {
  const hostData = useAtomValue(hostDataAtom);
  const baseUrl = `https://${hostData.aws_bucket}.s3.${hostData.aws_region}.amazonaws.com/${hostData.s3_endpoints_path}/`;
  return (
    <div
      className={mergeClass(
        "w-full pl-10 pr-2 py-2 font-medium rounded-sm text-sm text-white flex flex-col gap-2",
        {
          "bg-grayBg": published === false,
          "bg-successGreen": published === true,
        },
      )}
    >
      <div className="">
        {published ? "Content up to date" : "Unpublished changes"}
      </div>
      <div className="flex gap-1 text-sm">
        <Button
          onClick={() => handlePublishPressed()}
          className={mergeClass("py-1 px-3", {
            "bg-successGreen border-successGreen": !published,
            "bg-grayBg border-grayBg": published,
          })}
          disabled={isPublishing}
          title="Update published data"
        >
          <div className="flex gap-2">
            Publish
            {isPublishing && <Spinner />}
          </div>
        </Button>
        {modelsAndSingleItems && (
          <div
            className={mergeClass(
              "text-dark px-3 py-1 relative group transition cursor-pointer",
              "bg-primaryColor border-primaryColor border text-white font-medium",
              "hover:bg-white hover:text-primaryColor hover:border-primaryColor",
              {
                "bg-successGreen border-successGreen": !published,
                "bg-grayBg border-grayBg": published,
              },
            )}
          >
            View data
            <div
              className={
                "absolute top-full left-0 bg-white text-xs invisible group-hover:visible border z-10"
              }
            >
              {modelsAndSingleItems.map((item, index) => (
                <Link
                  key={index}
                  to={`${baseUrl}${item}.json`}
                  target="_blank"
                  title={`View ${item}.json`}
                >
                  <button className="px-3 py-2 hover:bg-grayBg w-full text-left">
                    {`${item}.json`}
                  </button>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
